// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"f68c0ac8","440":"57795238","453":"9ce9b81a","841":"c77d07ba","913":"71723467"}[chunkId] + ".chunk.js";
};